import leaseSlice from './lease-slice';
export const {
  leaseDetailsFormAction,
  resetLeaseAction,
  rentDetailsFormAction,
  setSearchApiParamsAction,
  setLeasesAction,
  setPageAction,
  setPerPageAction,
} = leaseSlice.actions;

export default leaseSlice;
